import axios from "axios";

axios.defaults.headers.common["Content-Type"] = "application/json";

const AxiosService = () => {
  let AuthorizationToken = null;

  function addHeaders(userConfig) {
    let globalHeaders = {};
    const csrfToken = document
      .querySelector("meta[name~=_token]")
      .getAttribute("content");

    if (csrfToken) {
      globalHeaders = {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": document
          .querySelector("meta[name~=_token]")
          .getAttribute("content"),
      };
    }

    const { headers } = userConfig;

    return {
      headers: {
        ...globalHeaders,
        ...headers,
      },
    };
  }

  // Set authorization token
  function setAuthorizationToken(token) {
    AuthorizationToken = token;
  }

  // GET method
  function get(endPoint, userConfig = {}) {
    return axios.get(`${endPoint}`, addHeaders(userConfig));
  }

  // POST method
  function post(endPoint, params = {}, userConfig = {}) {
    return axios.post(
      `${endPoint}`,
      params,
      addHeaders(userConfig)
    );
  }

  // PUT method
  function put(endPoint, params = {}, userConfig = {}) {
    return axios.put(
      `${endPoint}`,
      params,
      addHeaders(userConfig)
    );
  }

  // PATCH method
  function patch(endPoint, params = {}, userConfig = {}) {
    return axios.patch(
      `${endPoint}`,
      params,
      addHeaders(userConfig)
    );
  }

  // DELETE method
  function del(endPoint, userConfig = {}) {
    return axios.delete(`${endPoint}`, addHeaders(userConfig));
  }

  return {
    setAuthorizationToken,
    get,
    post,
    put,
    patch,
    del,
  };
};

// let's return back our create method as the default.
export default AxiosService();
